module.exports = __webpack_public_path__ + "img/tradeBlackBoxModel2.5988290e.png";